import { ComponentFactoryResolver, ComponentRef, Injectable, ViewContainerRef } from "@angular/core";
import { Subject } from "rxjs";
import { take } from "rxjs/operators";
import { ModalBoxComponent } from '../../shared/components/modal-box/modal-box.component'
import { ValidatorFn } from "@angular/forms";

type ModalType = 'modal' | 'submit' | 'twoAction';

export type modalResult = { action: 'closeAction' | 'firstAction' | 'secondAction', checkbox?: boolean, textboxValue?: string };

export interface TextboxOptions{
  labelHtml: string
  placeholder?: string
  errorMessage?: string
  validations?: ValidatorFn[]
}
export interface ModalOptions{
  modalTitle: string;
  titleSize?: string;
  modalBody: string;
  okButtonText?: string;
  cancelButtonText?: string;
  color?: string;
  type?: ModalType;
  checkbox?: boolean;
  checkboxText?: string;
  titleIcon?: string;
  checkRequiredToSubmit?: boolean;
  secondCheckbox?: boolean;
  secondCheckboxText?: string;
  secondCheckRequiredToSubmit?: boolean;
  smallTitleWidth?: boolean;
  slotsFull?: boolean;
  equalButtonsWidth?: boolean;
  textbox?: boolean;
  textboxOptions?: TextboxOptions;
  modalWidth?: string;
}
@Injectable({ providedIn: 'root' })
export class ModalService {
  private componentRef!: ComponentRef<ModalBoxComponent>;
  private componentSubscriber!: Subject<modalResult>;
  entry: ViewContainerRef;
  constructor(private resolver: ComponentFactoryResolver) { }


  openModal(modalOptions: ModalOptions) {
    let factory = this.resolver.resolveComponentFactory(ModalBoxComponent);
    const modalValues: ModalOptions = {
      okButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      color: 'danger',
      type: 'modal',
      checkbox: false,
      checkboxText: '',
      titleIcon: '',
      checkRequiredToSubmit: false,
      secondCheckbox: false,
      secondCheckboxText: '',
      secondCheckRequiredToSubmit: false,
      smallTitleWidth: false,
      slotsFull: false,
      equalButtonsWidth: false,
      textbox: false,
      textboxOptions: undefined,
      titleSize: '',
        ...modalOptions
    }
    this.componentRef = this.entry.createComponent(factory);
    this.componentRef.instance.titleText = modalValues.modalTitle;
    this.componentRef.instance.titleSize = modalValues.titleSize;
    this.componentRef.instance.text = modalValues.modalBody;
    this.componentRef.instance.okButtonText = modalValues.okButtonText;
    this.componentRef.instance.cancelButtonText = modalValues.cancelButtonText;
    this.componentRef.instance.color = modalValues.color;
    this.componentRef.instance.type = modalValues.type;
    this.componentRef.instance.checkbox = modalValues.checkbox;
    this.componentRef.instance.checkboxText = modalValues.checkboxText;
    this.componentRef.instance.secondCheckbox = modalValues.secondCheckbox;
    this.componentRef.instance.secondCheckboxText = modalValues.secondCheckboxText;
    this.componentRef.instance.smallTitleWidth = modalValues.smallTitleWidth;
    this.componentRef.instance.secondCheckRequiredToSubmit = modalValues.secondCheckRequiredToSubmit,
    this.componentRef.instance.titleIcon = modalValues.titleIcon;
    this.componentRef.instance.checkRequiredToSubmit = modalValues.checkRequiredToSubmit,
    this.componentRef.instance.equalButtonsWidth = modalValues.equalButtonsWidth,
    this.componentRef.instance.slotsFull = modalValues.slotsFull,
    this.componentRef.instance.textbox = modalValues.textbox, 
    this.componentRef.instance.textboxOptions = modalValues.textboxOptions,
    this.componentRef.instance.modalWidth = modalValues.modalWidth,
    this.componentRef.instance.closeAction.subscribe(() => this.closeModal());
    this.componentRef.instance.modalAction.subscribe(() => this.confirm());
    this.componentRef.instance.secondModalAction.subscribe(() => this.secondModalAction());
    this.componentRef.instance.modalActionWithCheckbox.subscribe((e) => this.modalActionWithCheckbox(e));
    this.componentRef.instance.modalActionWithTextbox.subscribe((e)=> this.modalActionWithTextbox(e));
    this.componentRef.instance.modalCloseActionWithCheckbox.subscribe((e) => this.modalCloseActionWithCheckbox(e));
    this.componentSubscriber = new Subject<modalResult>();
    return this.componentSubscriber.asObservable();
  }
  closeModal() {
    this.componentSubscriber.next({action: 'closeAction'});
    this.componentSubscriber.complete();
    this.componentRef.destroy();
  }

  confirm() {
    this.componentSubscriber.next({action: 'firstAction'});
    this.closeModal();
  }
  secondModalAction() {
    this.componentSubscriber.next({action: 'secondAction'});
    this.closeModal();
  }
  modalActionWithCheckbox(e) {
    this.componentSubscriber.next({action: 'firstAction', checkbox: e});
    this.closeModal();
  }
  modalCloseActionWithCheckbox(e) {
    this.componentSubscriber.next({action: 'closeAction', checkbox: e});
    this.closeModal();
  }
  modalActionWithTextbox(e){
    this.componentSubscriber.next({action:'firstAction', textboxValue:e});
      this.closeModal();
  }
}
